import { render, staticRenderFns } from "./index.vue?vue&type=template&id=271b6008&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=271b6008&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271b6008",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('271b6008')) {
      api.createRecord('271b6008', component.options)
    } else {
      api.reload('271b6008', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=271b6008&scoped=true", function () {
      api.rerender('271b6008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/historicRecords/index.vue"
export default component.exports